import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { legalContent } from '../data/content';
import { CloseIcon } from './icons/LineIcons';
export type LegalDoc = 'privacy' | 'terms';
type LegalModalProps = {
  doc: LegalDoc | null;
  onClose: () => void;
};
export function LegalModal({
  doc,
  onClose
}: LegalModalProps) {
  useEffect(() => {
    if (!doc) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [doc, onClose]);
  const content = doc ? legalContent[doc] : null;
  return <AnimatePresence data-id="element-281" data-mp="1hsve50sr5tex">
      {content ? <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.22
    }} className="fixed inset-0 z-[60] flex items-end justify-center bg-black/80 p-0 backdrop-blur-sm sm:items-center sm:p-6" onClick={onClose} data-id="element-282" data-mp="1hrkbx5eygtpx">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" initial={{
        opacity: 0,
        y: 24,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} transition={{
        duration: 0.28,
        ease: 'easeOut'
      }} onClick={event => event.stopPropagation()} className="relative w-full max-w-2xl overflow-hidden rounded-t-card border border-white/[0.08] bg-anthracite shadow-[0_40px_120px_-30px_rgba(0,0,0,0.9)] sm:rounded-card" data-id="element-283" data-mp="1frmbds0lg35n">
            <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" data-id="element-284" data-mp="16qxv0qnq9qpl" />
            <div className="flex items-start justify-between gap-6 border-b border-white/[0.07] px-6 py-5 sm:px-8" data-id="element-285" data-mp="e6pms6oqxv0o">
              <h2 id="legal-modal-title" className="font-display text-xl uppercase tracking-wide text-white sm:text-2xl" data-id="element-286" data-mp="65rtmgbfehyv">
                {content.title}
              </h2>
              <button type="button" onClick={onClose} aria-label="Cerrar" className="grid h-9 w-9 shrink-0 place-items-center rounded-md border border-steel/70 text-white/80 transition-colors duration-300 hover:border-gold/60 hover:text-gold" data-id="element-287" data-mp="aykyr5at3sbh">
                <CloseIcon className="h-4 w-4" data-id="element-288" data-mp="3tcu2vd4yhuxa" />
              </button>
            </div>

            <div className="modal-scroll max-h-[65vh] overflow-y-auto px-6 py-6 sm:px-8" data-id="element-289" data-mp="3ocxy3bofpzgo">
              <ul className="space-y-6" data-id="element-290" data-mp="18m3383xfq89o">
                {content.sections.map(section => <li key={section.heading} data-id="element-291" data-mp="13nibyu05uyxd">
                    <h3 className="font-sans text-[11px] uppercase tracking-[0.22em] text-gold" data-id="element-292" data-mp="13mqh5lee1585">
                      {section.heading}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-ash" data-id="element-293" data-mp="1g6dpm76ip3j3">
                      {section.body}
                    </p>
                  </li>)}
              </ul>
            </div>

            <div className="border-t border-white/[0.07] px-6 py-5 sm:px-8" data-id="element-294" data-mp="166wm9weqn1qa">
              <button type="button" onClick={onClose} className="w-full rounded-md bg-gold px-6 py-3 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:bg-goldsoft sm:w-auto sm:px-8" data-id="element-295" data-mp="1txitjlgx4hz8">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div> : null}
    </AnimatePresence>;
}